import PropTypes from "prop-types";
import { Typography } from "@mui/material";

const baseHeaderSx = {
  fontWeight: 800,
  color: "primary.main",
  letterSpacing: 0.2,
  position: "relative",
  display: "inline-flex",
  pb: 0.5,
  "&::after": {
    content: '""',
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    height: 3,
    borderRadius: 999,
    bgcolor: "primary.main",
    opacity: 0.35,
  },
};

const SectionHeader = ({ children, variant = "h6", sx = {}, ...props }) => {
  return (
    <Typography variant={variant} sx={{ ...baseHeaderSx, ...sx }} {...props}>
      {children}
    </Typography>
  );
};

SectionHeader.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.string,
  sx: PropTypes.object,
};

export default SectionHeader;
